import React, { useEffect } from 'react'
import Header from '../../components/layouts/Header';
import Main from './components/Main';
import Footer from '../../components/layouts/Footer';

export default function Home() {
    useEffect(() => {

    }, []);
    return (
        <>
            <Header />
            <Main />
            <Footer />
        </>
    )
}
